import moment from 'moment'
import swal from 'sweetalert';
import { mapState } from "vuex";
import { authComputed } from "../store/helpers";
import { AppInsights } from "applicationinsights-js";
import Sorting from '../utility/utility';
import DeepDiff from '../utility/DeepDiffAlgorithm';

export default {
    computed: {
        ...authComputed,
        ...mapState("auth", ["user"]),
    },
    directives: {
        numericOnly: {
            bind(key, binding) {
                key.addEventListener('keypress', (e) => {
                    let charCode = (e.which) ? e.which : e.keyCode;
                    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && binding.value) {
                        e.preventDefault();
                    } else {
                        return true;
                    }
                });
            },
        },
        numericWithOutDot: {
            bind(key, binding) {
                key.addEventListener('keypress', (e) => {
                    let charCode = (e.which) ? e.which : e.keyCode;
                    if ((charCode > 31 && (charCode < 48 || charCode > 57) && binding.value)) {
                        e.preventDefault();
                    } else {
                        return true;
                    }
                });
            }
        },
        numericWithComma: {
            bind(key,binding) {
                key.addEventListener('keypress', (e) => {
                    let charCode = (e.which) ? e.which : e.keyCode;
                    let  isNotNumeric = (charCode > 31 && (charCode < 48 || charCode > 57));
                    if(binding.value.allowComma.filterTypeOperatorID == 6 || binding.value.allowComma.filterTypeOperatorID == 7 || binding.value.allowComma.filterTypeOperatorID == 8){
                        //Allwed characters are (a-z A-Z 0-9 * @ & , _ - )
                        isNotNumeric = isNotNumeric && charCode != 38 && charCode != 42 && charCode != 44 && charCode != 45 && 
                                                       charCode != 64 && charCode != 95 && (charCode < 97 || charCode > 122) && (charCode < 65 || charCode > 90);
                    } 
                    if(isNotNumeric){
                        e.preventDefault();
                    }
                    else{
                        return true;
                    }
                });
            }
        }
    },
    methods: {
        sortRecords(origArray, column, isAscending, columnCaseInsensitive = false) {
            var valueArray = JSON.parse(JSON.stringify(origArray))
            return valueArray.sort(function(a, b) {
                var fieldValueA = a[column];
                var fieldValueB = b[column];
                if(!columnCaseInsensitive) {
                    fieldValueA = fieldValueA.toLowerCase();
                    fieldValueB = fieldValueB.toLowerCase();
                }
                if (isAscending) {
                    return fieldValueA > fieldValueB ? 1 : fieldValueB > fieldValueA ? -1 : 0;
                }
                else {
                    return fieldValueB > fieldValueA ? 1 : fieldValueA > fieldValueB ? -1 : 0;
                }
            });
        },
        sortNumbers(origArray, column, isAscending) {
            // if the array is concatenate with empty array it gives a new reference
            var valueArray = origArray.concat([]);
            if(valueArray && valueArray.length > 0){
                if (isAscending) {
                    return valueArray.sort(function(a, b) {
                        return a[column] > b[column] ? 1 : b[column] > a[column] ? -1 : 0;
                    });
                } else {
                    return valueArray.sort(function(a, b) {
                        return b[column] > a[column] ? 1 : a[column] > b[column] ? -1 : 0;
                    });
                }
            }
        },
        formatDate(value, formatString) {
            if (value && formatString) {
                let date = new Date(value);
                return moment(date).format(formatString)
            }
        },
        subtractDateValue(dateValue, day, formatString) {
            if (dateValue && formatString) {
                let date = new Date(dateValue);
               return  moment(date).subtract(day, 'day').format(formatString)
            }
        },
        formatUTCDate(value, formatString) {
            if (value && formatString) {
                let date = new Date(value).toUTCString();
                return moment.utc(date).format(formatString);
            }
        },
        deepCopy(input) {
            var output, v, key;
            output = Array.isArray(input) ? [] : {};
            for (key in input) {
                v = input[key];
                output[key] = (typeof v === "object") ? this.deepCopy(v) : v;
            }
            return output;
        },
        getWeekDay(value) {
            switch (value) {
                case 0:
                    return "Sunday";
                case 1:
                    return "Monday";
                case 2:
                    return "Tuesday";
                case 3:
                    return "Wednesday";
                case 4:
                    return "Thursday";
                case 5:
                    return "Friday";
                case 6:
                    return "Saturday";
            }
        },
        runErrorRoutine(message, pageData, pageProps, pageRoute, error) {  
            let errorMessage = '';
            let errorDetailSummary = '';
            let errorSummary = '';
            let errorTitle = '';
            let errorValue = '';
            if (error && error.response) {
                errorTitle = 'API Error';
                if (error.response.status != 401 && (!error.response.data || !error.response.data.summary || !error.response.data.detailSummary)) {
                    errorDetailSummary = message + '\n\n' + "when calling API and no error message returned";
                } 
                else if(error.response && error.response.status === 401) {
                    errorValue = error;
                }
                else {
                    errorSummary = error.response.data.summary ? error.response.data.summary:'';
                    errorDetailSummary = error.response.data.detailSummary ? error.response.data.detailSummary.join("\n"):'';
                    message = '';
                }
                errorMessage = message +'\n'+ errorValue +'\n'+ errorSummary + '\n\n' + errorDetailSummary;
            }
            else {
                errorTitle = 'Error';
                errorMessage = message + '\n\n' + error;
            }
            swal({ title: errorTitle, text: errorMessage, icon: 'error', button: true, dangerMode: true, });
            if (this.user) {
            errorMessage += '  User: ' + this.user.name;
            }
            errorMessage += '  PageData: ' + JSON.stringify(pageData);
            errorMessage += '  PageProps: ' + JSON.stringify(pageProps);
            errorMessage += '  PageRoute: ' + JSON.stringify(pageRoute);
            AppInsights.trackException(errorMessage);
        },
        getTimeFromAudioDuration(duration) {
            //.replace(".",":")
            let time = duration.toString().split('.');        
            return "00:" + this.convertToTwoDigits(time[0]) + ":" + (time.length > 1 ? this.convertToTwoDigits(time[1]) : '00');            
        },
        convertToTwoDigits(value) {
            return ('0' + value).slice(-2);
        },
        dateRangeCheck(name, e){            
            let startDate = '';
            let endDate = '';
            var dateFrom = this.formatUTCDate(new Date(),'MM-DD-YYYY');
            var dateTo = this.formatUTCDate(new Date(),'MM-DD-YYYY');
            var fromTime = this.formatDate(this.fromTime,'HH:mm');
            var toTime = this.formatDate(this.toTime,'HH:mm');

            startDate = (name === 'startDate' ? (e ? e : (fromTime? dateFrom: null)) : (this.datetimeFrom ? this.datetimeFrom : (fromTime? dateFrom: null)));

            endDate = (name === 'endDate' ? (e ? e : (toTime? dateTo : null)) : (this.datetimeTo ? this.datetimeTo : (toTime? dateTo: null)));

            startDate = (name == 'startTime' ? (e? (startDate + ' ' + e) : startDate) : fromTime ? (startDate + ' ' + fromTime) : startDate);

            endDate = (name == 'endTime' ? (e? (endDate + ' ' + e) : endDate) : toTime? (endDate + ' ' + toTime) : endDate);

            startDate = fromTime ? startDate : startDate? (startDate + ' 00:00:00') : startDate;

            endDate = toTime? endDate : endDate? (endDate + ' 23:59:59') : endDate;

            startDate = startDate? new Date(startDate) : null;
            
            endDate = endDate? new Date(endDate) : null;

            return {startDate, endDate};
        },
        dateRangeValidation(){
            let showError=[];
            let startTime = this.fromTime ? this.formatDate(this.fromTime, 'HH:mm') : null;
            let endTime = this.toTime? this.formatDate(this.toTime, 'HH:mm') : null;
            let startDateTime = this.formatDate(new Date(), 'YYYY-MM-DD');
            let endDateTime = this.formatDate(new Date(), 'YYYY-MM-DD');

            if(this.datetimeFrom)
                startDateTime = this.datetimeFrom;
            if(this.datetimeTo)
                endDateTime = this.datetimeTo;
            if(this.fromTime)
                startDateTime = startDateTime + " " + startTime;
            if(this.toTime)
                endDateTime = endDateTime + " " + endTime;
            if(this.fromTime && this.toTime == null)
                endDateTime = endDateTime + " " + "23:59";
            if(!this.datetimeFrom && !this.fromTime) return showError;

            if(!this.datetimeTo && !this.toTime) return showError;

            if(new Date(startDateTime) > new Date(endDateTime)){
                showError.push({msg: "Start time should not be greater than end time"});
            }
            return showError;
        },
        totalColumnValue(list,columnName){
            if(list && columnName){
            return list.map(row=> row[columnName]).reduce((a, c) => { return a + c });
            }
        },

        getLanguageId(languages, pageFilters) {
            var languageID = '';
                var filteredList = pageFilters.filter(row => row.filterName == 'language')
                if(filteredList.length > 0 ){
                    var Language = languages.filter(r => r.languageValue == filteredList[0].filterValue)
                    if(Language.length > 0 ) languageID = Language[0].languageID;
                }
            return languageID;
        },

        sortVoiceByLanguage(voiceData, languageID) {
            var voiceDataList =  voiceData
            if(languageID){
                voiceDataList = voiceData.filter(voice => voice.languageID == languageID);
            }
            var sortedVoiceData = this.sortRecords(voiceDataList, 'voiceName', true); 
            return sortedVoiceData.map((item)=>{
                return {    
                    OptionID: item.voiceID,
                    OptionName: item.voiceName, 
                    OptionValue: item.voiceName   
                }
            })
        },

        filterVoiceDropdown(voiceData, filterDropdowns, filterDropdownValues){
            var languageID = ""
            var filterDropdownsList = filterDropdowns.filter(r => r.DropdownOptions.some(row => row.OptionValue == event.target.value))
            if(filterDropdownsList.length > 0 ){
                var selectedfilterDropdownsList = filterDropdownsList[0].DropdownOptions.filter(row => row.OptionValue == event.target.value)
                languageID = selectedfilterDropdownsList[0].OptionID
            } 
            var options = this.sortVoiceByLanguage(voiceData, languageID)  
            
            filterDropdowns.map((r)=>{
                if(r.DropdownName == "voice"){
                    r.DropdownOptions = options;
                    r.CurrentValue = "";

                }
            })
            var index = filterDropdownValues.findIndex(it => it.filterName === "voice");
            if(index != -1) filterDropdownValues.splice(index, 1);
            
            if(this.parentName) {
                var pageFilter = {
                    pageName: this.parentName,
                    filterName: 'voice',
                    filterValue: ""
                }
                this.updatePageFilter(pageFilter);
            }
            return filterDropdowns;
        },
        getMinIntrevalValue(scheduleData){
            let minInterval = 15;
            var campaignDailySchedules = scheduleData.campaignDailySchedules.filter(row=>row.status == "Active")
            var campaignDayPart = campaignDailySchedules.map(r => r.campaignDayPartSchedules.map(row => row.endMinute - row.startMinute))
            if(campaignDayPart.length > 0){
                minInterval = Math.min(...[].concat(...campaignDayPart))
            }
           return  minInterval;
        },
        validateIntervalCaps(campaignIntervalCaps, intervalData){
            var filterIntervalData = (campaignIntervalCaps && campaignIntervalCaps.length > 0)? campaignIntervalCaps.filter(row=> row.status == "Active") : null;
            var intervalList = filterIntervalData.map(row => row.endMinute - row.startMinute);
            var interval = 0;
            if(intervalList.length > 0){
                interval = Math.max(...[].concat(...intervalList))
                interval = (interval == 45) ? 60 : interval;
            }
            var defaultInterval = null;
            var isIntervalDisabled =  intervalData.some(row => row.defaultIntervalValue == interval && row.isDisabled);
            if(isIntervalDisabled)
            {
               defaultInterval = interval;
            }
            return defaultInterval;
        },
        sortListRecord(filteredData,sortField,settings,sortBy){
            return Sorting.sortListValue(filteredData,sortField,settings,sortBy);
        },
        sortFields(filteredData,sortField,sortBy){
            return Sorting.sortFields(filteredData,sortBy,sortField);
        },
        sortMultipleCols(filteredData,sortField,sortBy,settings){
            return Sorting.sortMultipleCols(filteredData,sortField,sortBy,settings);
        },
        getDefaultSortColumnOptions(settings){
            return Sorting.getDefaultSortColumnOptions(settings);
        },
        getPartnerNameByID(partnerData, Id){
            var data = partnerData.filter(x=>x.partnerID == Id)
            return data && data.length > 0 ? data[0].name : '';
        },
        getAffiliateNameByID(affiliateData, Id){
            var data = affiliateData.filter(x=>x.campaignSourceTypeId == Id)
            return data && data.length > 0 ? data[0].campaignSourceTypeName : '';
        },
        getCallTypeNameByID(callTypeData, Id){
            var data = callTypeData.filter(x=>x.campaignCallTypeId == Id)
            return data && data.length > 0 ? data[0].campaignCallTypeName : '';
        },
        getAffilicateTypeNameByID(affiliateTypesData, Id){
            var data = affiliateTypesData.filter(x=>x.affiliateTypeId == Id)
            return data && data.length > 0 ? data[0].typeName : '';
        },
        getTransferDataNameByID(transferData, Id){
            var data = transferData.filter(r=>r.pingTransferTypeId == Id);
            return data && data.length > 0 ? data[0].pingTransferTypeName : '';  
        },
        getCallPathNameByID(campaignData, Id){
            var data = campaignData.filter(r=>r.callPathID == Id);
            return data && data.length > 0 ? data[0].callPathName : '';  
        },
        getStatusNameByID(statuses, Id){
            var data = statuses.filter(x=>x.statusID == Id)
            return data && data.length > 0 ? data[0].statusName : '';
        },
        getFilterNameByID(filterData, Id){
            var data = filterData.filter(r=>r.subscriptionFilterTypeID == Id);
            return data && data.length > 0 ? data[0].subscriptionFilterTypeName : '';  
        },
        getFilterOperatorIdByName(filterOperatorData, Name){
            var data = filterOperatorData.filter(r=>r.filterTypeOperatorName == Name);
            return data && data.length > 0 ? data[0].filterTypeOperatorID : '';  
        },
        convertSecondsToTime(seconds){
            var tt = "AM";
            if(seconds >= 720){
                tt = "PM";
                seconds = seconds - 720;
            }
            var hours = Math.floor(seconds / 60);
            var minute = seconds - (hours * 60);
            minute = minute == 0 ? "00" : minute;
            seconds = seconds == 0 ? "00" : seconds;
            return hours == 0 ? ("12." + seconds + " AM" ): (hours + "." + minute +  tt);
         },
        arrayToObject (arr) {
            return arr.reduce((obj, item) => {
                const key = Object.keys(item)[0]
                obj[key] = item[key]
                return obj
            }, {});
        },
        removeNullFieldToArray(data){
            return Object.entries(data).reduce((a,[key,val])=>{
                if(val)
                    a.push({ [key] : val});
                return a;
            },[]);
        },
        getLanguageByID(promptLanguageList,language){
            var data = promptLanguageList.filter(x=>x.languageValue  == language);
            return data && data.length > 0 ? data[0].languageName : '';
        },
        getPromptDataName(id){
            var test = this.transferPromptData.filter(r=>r.transferPromptId == id);
            return test && test.length > 0 ? test[0].transferPromptName : 'Enable Client Name'; // default selected value
        },
        formTazClientAuditLogDescription(category, subcategory, uniqueIdentifierName, oldObj, newObj){ 
            var resultArr = DeepDiff.findDiffBetweenTwoObjects(category, oldObj, newObj);
            var description = "";
            if((!resultArr.Before && !resultArr.After) || (JSON.stringify(resultArr.Before) == '{}' && JSON.stringify(resultArr.After) == '{}'))
              description = "";
            else
              description = JSON.stringify({UniqueIdentifierName: uniqueIdentifierName, Before: JSON.stringify(resultArr.Before), After: JSON.stringify(resultArr.After)});
            var actionAndIdentifier = DeepDiff.getActionTypeByParentUniqueID(oldObj, newObj, resultArr.Before,resultArr.After)
            var tazClientAuditLog = {
                category: category,
                subcategory: subcategory,
                uniqueIdentifier: actionAndIdentifier.uniqueIdentifier,
                actionType: actionAndIdentifier.actionType,
                description: description
            }
            return tazClientAuditLog;
         },
    }
};